import { createBrowserRouter } from 'react-router-dom'

import GlobalLayout from 'app/GlobalLayout'
import { AppRoutes } from 'app/model/app-router'

export const Routing = createBrowserRouter([
  {
    path: '/',
    shouldRevalidate: () => false,
    element: <GlobalLayout />,
    children: AppRoutes,
  },
])
